import React, { useEffect, useState } from 'react'
import { Form } from './Form'
import { AuthList } from './AuthList'
import { Accordion } from 'src/components/era-package'
import { faMoneyCheckDollarPen } from '@fortawesome/pro-regular-svg-icons'
import AbiUserSettingsApiUrls from 'src/apiUrls/AbiUserSettingsApiUrls'
import AbiTradePartnerApiUrls from 'src/apiUrls/AbiTradePartnerApiUrls'

const PAYMENT_TYPES_USER_SETTINGS = [2, 6]
const PAYMENT_TYPES_TRADE_PARTNER = [3, 5, 7, 8]

export const Authorization = ({ list: initialList, firstEntryPaymentType, ...statement }) => {

  const [expanded, setExpanded] = useState(true)
  const [list, setList] = useState(initialList || [])
  const [defaultPayerUnitNumber, setDefaultPayerUnitNumber] = useState('')

  const { importerNumber } = statement

  useEffect(() => {
    const payType = Number(firstEntryPaymentType)
    if (!payType) return

    const token = 'Bearer ' + JSON.parse(localStorage.getItem('userToken'))

    if (PAYMENT_TYPES_USER_SETTINGS.includes(payType)) {
      fetch(AbiUserSettingsApiUrls.GET, { headers: { Authorization: token } })
        .then(r => r.json())
        .then(res => setDefaultPayerUnitNumber(res.data?.payersUnitNumber || ''))
        .catch(() => setDefaultPayerUnitNumber(''))
    } else if (PAYMENT_TYPES_TRADE_PARTNER.includes(payType) && importerNumber) {
      fetch(`${AbiTradePartnerApiUrls.GET}?importerNumber=${encodeURIComponent(importerNumber)}&partyCode=IM`, { headers: { Authorization: token } })
        .then(r => r.json())
        .then(res => setDefaultPayerUnitNumber(res.data?.payersUnitNumber || ''))
        .catch(() => setDefaultPayerUnitNumber(''))
    }
  }, [firstEntryPaymentType, importerNumber])

	const handleFormSubmit = (newItems) => {
        console.log(list);
        console.log(initialList);
        console.log(newItems);
        setList(newItems);
	};

  return <>
    <Form {...statement} payerUnitNumber={defaultPayerUnitNumber} onSubmit={handleFormSubmit} />
    <Accordion title='Statement Authorization List'
      icon={faMoneyCheckDollarPen}
      expanded={expanded}
      onChange={(e, state) => setExpanded(state)}
      DetailsProps={{ sx: { p: 0 } }}
    >
      <AuthList authData={list} statement={statement} />
    </Accordion>
  </>
}
